var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "game-item",
      class: { "viewport-intersected": _vm.isMounted },
      on: { mouseover: _vm.hover, mouseleave: _vm.leave }
    },
    [
      _c(
        "div",
        {
          staticClass: "game-item__box",
          on: {
            click: function($event) {
              return _vm.$el.classList.toggle("active")
            }
          }
        },
        [
          _vm.restrictionReasonTranslationKey
            ? _c("div", { staticClass: "game-item__game-restricted" }, [
                _c("img", {
                  attrs: {
                    src: "/public/icons/game-restricted-r.svg",
                    alt: "Game restricted"
                  },
                  on: { click: _vm.showRestrictionMessage }
                })
              ])
            : _vm._e(),
          _c("picture", [
            _c("source", {
              attrs: { srcset: _vm.gameWebpImageSrcset, type: "image/webp" }
            }),
            _c("img", {
              attrs: { src: _vm.gameJpgImageSrc, alt: _vm.item.title }
            })
          ]),
          _c(
            "div",
            {
              staticClass: "game-item__name",
              class: { "game-restricted": _vm.restrictionReasonTranslationKey }
            },
            [_vm._v("\n            " + _vm._s(_vm.item.title) + "\n        ")]
          ),
          _c("div", { staticClass: "label-top" }, [
            _vm.item.isNew
              ? _c("div", { staticClass: "label-new" }, [
                  _vm._v(_vm._s(_vm.$t("front.game.badge.new")))
                ])
              : _vm._e(),
            _c("div", { staticClass: "infGame" }, [
              _vm._v(_vm._s(_vm.item.platformTitle))
            ])
          ]),
          _c(
            "div",
            { staticClass: "game-item__hover" },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.user,
                      expression: "user"
                    }
                  ],
                  class: { active: _vm.isGameFavorite },
                  on: { click: _vm.switchFavoriteStatus }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "16",
                        viewBox: "0 0 18 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M8.36098 2.91864L8.9999 3.95816L9.63888 2.91867C10.3644 1.73841 11.6593 0.953613 13.1391 0.953613C15.4095 0.953613 17.25 2.79406 17.25 5.06441C17.25 6.29893 16.704 7.40389 15.8384 8.15893L15.8192 8.17572L15.8011 8.19379L8.99994 14.9952L2.19879 8.19379L2.18073 8.17573L2.16148 8.15894C1.29597 7.40392 0.75 6.29896 0.75 5.06441C0.75 2.79393 2.59001 0.953613 4.86029 0.953613C6.3402 0.953613 7.63565 1.73851 8.36098 2.91864Z",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      })
                    ]
                  )
                ]
              ),
              _c("h4", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.item.title) +
                    "\n                "
                ),
                _c("span", [_vm._v(_vm._s(_vm.item.platformTitle))])
              ]),
              _c(
                "router-link",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.playForReal,
                      expression: "item.playForReal"
                    }
                  ],
                  staticClass: "play",
                  attrs: { to: _vm.gamePlayRealUrl, event: "" },
                  nativeOn: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.playForReal($event)
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("front.game.button.play_real")))
                  ])
                ]
              ),
              _c(
                "router-link",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isPlayForFunAllowed,
                      expression: "isPlayForFunAllowed"
                    }
                  ],
                  staticClass: "play-free",
                  attrs: { to: _vm.gamePlayFunUrl, event: "" },
                  nativeOn: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.playForFun($event)
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("front.game.button.play_free")))
                  ])
                ]
              ),
              _c(
                "router-link",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.hasInfoPage,
                      expression: "item.hasInfoPage"
                    }
                  ],
                  staticClass: "information",
                  attrs: { to: _vm.gameInfoUrl }
                },
                [
                  _c("img", {
                    attrs: { src: _vm.gameInfoImage, alt: _vm.item.title }
                  })
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }